import { View, html } from 'rune-ts';
import klass from './Toggle.module.scss';

export interface IToggle {
  setSetting(setting: boolean): void;
  getSetting(): boolean;
}

export interface TProps {
  name?: string;
  setting?: boolean;
  disabled?: boolean;
  onClick?: (view: IToggle, event: MouseEvent) => void;
}

/**
 * @remarks 상품 카드 에픽이 마플샵 브랜치에 머지되면 디자인 시스템 폴더 레이어로 이동 필요
 */
export class Toggle extends View<TProps> {
  private setting: boolean;
  private readonly originalOnClick: TProps['onClick'];

  constructor(data: TProps) {
    super(data);
    this.setting = Boolean(data.setting);
    this.originalOnClick = this.data.onClick;
  }

  protected override template({ disabled, name }: TProps) {
    return html`
      <button
        type="button"
        class="${klass.toggle} ${this.setting ? klass.on : ''} ${disabled ? klass.disabled : ''}"
        ${disabled ? 'disabled' : ''}
        ${name ? `name=${name}` : ''}
        aria-pressed="${this.setting}"
        role="switch"
      >
        <span class="${klass.track}">
          <span class="${klass.ball}"></span>
        </span>
      </button>
    `;
  }

  override onRender() {
    /* 토글 이벤트 */
    this.addEventListener('click', (event) => {
      this.originalOnClick?.(this, event);
    });
  }

  setSetting(setting: boolean) {
    this.setting = setting;

    if (this.setting) {
      this.element().classList.add(klass.on);
    } else {
      this.element().classList.remove(klass.on);
    }

    this.element().setAttribute('aria-pressed', String(this.setting));
  }

  getSetting() {
    return this.setting;
  }
}
